// Runtime configuration.
//
// Resolution order for every value:
//   1. window.__APP_CONFIG__ — written per environment by the container entrypoint, so
//      one image can serve staging and production (hf-apps-collection ADR-0008).
//   2. process.env.VUE_APP_* — the build-time value Vue CLI substitutes, still used by
//      `npm run serve` and Cloudflare Pages previews, which have no entrypoint.

declare global {
  interface Window {
    __APP_CONFIG__?: {
      auth0Domain?: string;
      auth0ClientId?: string;
      auth0Scope?: string;
      ahbExpressionBaseUrl?: string;
    };
  }
}

const runtime =
  (typeof window !== "undefined" ? window.__APP_CONFIG__ : undefined) ?? {};

// An empty string in config.js means "not configured for this environment", so it must
// fall through to the build-time value rather than override it with nothing.
const pick = (
  runtimeValue: string | undefined,
  buildTimeValue: string | undefined
): string | undefined => runtimeValue || buildTimeValue;

export const runtimeConfig = {
  auth0Domain: pick(runtime.auth0Domain, process.env.VUE_APP_AUTH0_DOMAIN),
  auth0ClientId: pick(
    runtime.auth0ClientId,
    process.env.VUE_APP_AUTH0_CLIENT_ID
  ),
  auth0Scope: pick(runtime.auth0Scope, process.env.VUE_APP_AUTH0_SCOPE),
  ahbExpressionBaseUrl: pick(
    runtime.ahbExpressionBaseUrl,
    process.env.VUE_APP_AHB_EXPRESSION_BASE_URL
  ),
};

// Deliberately NOT exposed: an Auth0 audience and EmailJS credentials. Nothing in src/
// reads them — main.ts never passes `audience` to the Auth0 plugin, and there is no
// EmailJS consumer — so publishing them as configuration would promise an effect that
// does not exist. Add them back together with the code that uses them.

export default runtimeConfig;
